<template>
  <div class="row blaStepFieldContainer" ref="list">
    <Loader :show="showLoader" />

    <div class="col-10 offset-1 col-md-8 offset-md-2">
      <div class="row align-content-center">
        <div class="col-12 col-md-8 offset-md-2">
          <div
            @click="$router.push({ name: 'chooser' })"
            class="blaStepFieldTitleButton text-center d-inline-block pr-1"
          >
            <i class="fas fa-angle-left"></i>
          </div>
          <div class="blaStepFieldTitle d-inline-block">Leckék</div>
          <div class="blaStepFieldTitleAlt">{{ course.title }}</div>
        </div>
      </div>
      <div
        v-for="chapter in chapters"
        :key="'chapter-' + chapter.id"
        class="row"
      >
        <div
          v-if="chapter.is_free === 0 && !subscription"
          class="col-12 col-md-8 offset-md-2 blaStepFieldBuyBox text-center"
        >
          <div class="row align-content-center">
            <div class="col-12 col-md-6">
              <div class="blaStepFieldBuyBoxTitle mt-0 mt-md-2">
                A tanulás folytatásához iratkozz be most!
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div
                class="blaStepFieldBuyBoxButton clickable"
                @click="goToOfferLink"
              >
                Csomagváltás
              </div>
            </div>
          </div>
        </div>

        <div
          v-for="lesson in chapter.lessons"
          :key="'lesson-' + lesson.id"
          class="col-12 col-md-7 offset-md-3 blaStepFieldBox clickable"
          :class="{
            blaStepFieldBoxImgDisable: !subscription && chapter.is_free === 0,
            blaStepFieldLessonDidNotSee: !lesson.saw,
          }"
          @click="goToLesson(chapter, lesson)"
        >
          <div class="row">
            <!-- Lesson Image -->
            <div
              class="col-12 col-md-12 text-center"
              @click="goToLesson(chapter, lesson)"
            >
              <img
                v-if="lesson.fileUrl !== null"
                :src="lesson.fileUrl"
                :alt="lesson.title"
                class="img-fluid blaStepFieldBoxImage"
              />
              <img
                v-else
                :src="require('@/assets/img/skillers_logo.png')"
                :alt="lesson.title"
                class="img-fluid blaStepFieldBoxImage"
                :class="{
                  blaStepFieldBoxImgDisable:
                    !subscription && chapter.is_free === 0,
                }"
              />
            </div>
          </div>
          <!-- Points -->
          <div class="row mt-2 blaStepFieldBoxScoreBottom">
            <!-- Lesson description -->
            <div class="col-10 offset-2 blaStepFieldBoxTitle mt-2">
              <div class="row">
                <div class="col-12">{{ lesson.description }}</div>
              </div>
            </div>
            <div class="col-12 col-md-10 offset-md-1">
              <div class="d-inline-block">
                <img
                  :src="require('@/assets/img/score.png')"
                  alt="score"
                  class="img-fluid blaStepFieldBoxScoreIcon d-inline-block"
                />
                <div class="blaStepFieldBoxScore d-inline">
                  {{ lesson.userPoints }}
                </div>
              </div>
              <div class="d-inline-block ml-3">
                <StepFieldStars :value="lesson.userSelfValue" />
              </div>
              <div
                v-if="lesson.viewCounter != null"
                class="d-inline-block ml-3"
              >
                <img
                  :src="require('@/assets/img/eye4.png')"
                  alt="score"
                  class="img-fluid blaStepFieldBoxScoreIcon mb-1 d-inline-block"
                />
                <div class="blaStepFieldBoxScore d-inline">
                  {{ lesson.viewCounter }}
                </div>
              </div>
            </div>
            <!-- <div class="col-4 mt-2">
              <StepFieldStars :value="lesson.userSelfValue" />
            </div> -->
            <div class="col-4"></div>
          </div>
        </div>
      </div>
      <!-- Loader -->
      <div class="row">
        <div
          v-if="showLessonLoader"
          class="col-12 col-md-8 offset-md-2 text-center mt-2"
        >
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import StepFieldStars from "@/components/partials/StepFieldStars";
import Loader from "@/components/partials/Loader";

export default {
  components: { Loader, StepFieldStars },
  data: function () {
    return {
      course: {},
      chapters: {},
      counter: 0,
      subscription: false,
      showLoader: true,
      showLessonLoader: false,
      loadCounter: 0,
    };
  },
  methods: {
    getStepFieldData() {
      //Not exists the subscription or course, redirect to chooser page
      if (this.$data.courseId === 0) {
        this.$router.push({ name: "chooser" });
      }

      //increase loadCounter & disable loading
      this.loadCounter += 2;
      this.enableLoad = false;

      axios
        .post(this.$store.getters.getApiUrl + "/api/lessons", {
          token: this.$store.getters.getToken,
          courseId: this.$store.getters.courseId,
          loadCounter: this.loadCounter,
        })
        .then((response) => {
          this.subscription = response.data.subscription;
          this.chapters = response.data.chapters;
          this.course = response.data.course;

          let v = this;

          //Disable loading screen
          setTimeout(function () {
            v.showLoader = false;
            v.showLessonLoader = false;
          }, 1000);

          //Enable scroll lazy loading
          setTimeout(function () {
            v.enableLoad = true;
          }, 2000);
        })
        .catch((error) => {
          if (error.length > 0) {
            console.log("stepfield - error: ", error);
          }
        });
    },
    goToLesson(chapter, lesson) {
      //TODO: Delete this - Only DEV!
      //   this.$store.commit("setCurrentLessonId", {
      //     currentLessonId: lesson.id,
      //   });
      //   this.$router.push({
      //     name: "selfValue",
      //     params: { lessonId: lesson.id },
      //   });

      //   Check user has a subscription or it is free
      if (chapter.is_free == 1) {
        //Load lesson
        this.loadLesson(lesson);
      } else {
        //If we have a subscription, we go to the prologue
        if (this.subscription) {
          //Load lesson
          this.loadLesson(lesson);
        } else {
          console.log("Nincs előfizetésünk ehhez");
          this.goToOfferLink(); //Redirect to the offer page
        }
      }
    },
    loadLesson(lesson) {
      //Save lesson id to store
      this.$store.commit("setCurrentLessonId", {
        currentLessonId: lesson.id,
      });

      //Check lesson type
      // 1 - CLASSIC - go to prologue
      // 2 - TEST - go to the test
      // 3 - VIDEO+TEST - go to the prologue
      // 4 - VIDEO+TEST+VIDEO - go to the prologue
      // 5 - AUDIO LESSON - go to audio lesson

      //Flush incorrect answers
      this.$store.commit("emptyIncorrectAnswers");

      switch (lesson.type) {
        case 1:
          //Go to prologue
          this.$router.push({
            name: "prologue",
            params: { lessonId: lesson.id },
          });
          break;

        case 2:
          //Go to test
          this.$router.push({
            name: "test",
            params: { lessonId: lesson.id },
          });
          break;

        case 3:
          //Go to video+test or video+test+video
          this.$router.push({
            name: "prologue",
            params: { lessonId: lesson.id },
          });
          break;

        case 4:
          //Go to video+test or video+test+video
          this.$router.push({
            name: "prologue",
            params: { lessonId: lesson.id },
          });
          break;

        case 5:
          //Go to audio
          this.$router.push({
            name: "audioBook",
            params: { lessonId: lesson.id },
          });
      }
      //   if (lesson.type == 1) {
      //     //Go to prologue
      //     this.$router.push({
      //       name: "prologue",
      //       params: { lessonId: lesson.id },
      //     });
      //   } else if (lesson.type == 2) {
      //     //Go to test
      //     this.$router.push({
      //       name: "test",
      //       params: { lessonId: lesson.id },
      //     });
      //   } else {
      //     //Go to video+test or video+test+video
      //     this.$router.push({
      //       name: "prologue",
      //       params: { lessonId: lesson.id },
      //     });
      //   }
    },
    onScroll() {
      var lessonList = this.$refs["list"];
      if (lessonList) {
        var marginTopOfTheList = lessonList.getBoundingClientRect().top;
        var marginBottomOfTheList = lessonList.getBoundingClientRect().bottom;
        var innerHeight = window.innerHeight;
        // console.log("theTop: ", marginTopOfTheList);
        // console.log("theBottom: ", marginBottomOfTheList);
        // console.log("innerHeight: ", innerHeight);
        // console.log("fire value: ", innerHeight - marginTopOfTheList);

        if (
          innerHeight - marginTopOfTheList > innerHeight / 2 + innerHeight &&
          this.enableLoad &&
          this.loadCounter < 60
        ) {
          this.showLessonLoader = true;
          this.getStepFieldData();
          console.log("scroll loading - active", this.loadCounter);
        }
      }
    },
    goToOfferLink() {
      window.location.href =
        "https://old.e-egyetem.hu/angol-tanfolyamok---beiratkozas-.html";
    },
  },
  computed: {
    ...mapGetters[("courseId", "user")],
  },
  mounted() {
    this.getStepFieldData();

    //Reset current lingron ID
    this.$store.commit("updateLastLingronId", {
      lastLingronId: null,
    });

    //Reset point & answers counters
    this.$store.dispatch("resetCounters");

    //If chapters id in the store 0, redirect to chooser
    if (this.$store.getters.courseId === 0) {
      this.$router.push({ name: "chooser" });
    }

    //Infinity scroll loading
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onScroll);
      this.onScroll(); // needed for initial loading on page
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
